import styled from 'styled-components';

export const ActionWrapper = styled.div`
    position: absolute;
    top: 5px;
    right: 5px;
    opacity: 1;
    z-index: 1;
    width:30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0 15px;
`;

export const MoreBox = styled.a`
    position: relative;
`;

export const MoreBoxIcon = styled.a`
    width:30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    opacity: .7;
    &:hover{
        opacity: 1;
    }
`;

export const PhoneBookCardWrapper = styled.div`
    position:relative;
    overflow: hidden;
    cursor: pointer;
    border-radius: 6px;
    padding:  15px 20px;
    background-color: ${({ theme }) => theme.colors.card.background};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    transition: background-color 0.2s ease;
`;

export const Tile = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
`;
export const IconWrapper = styled.div`
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Phone = styled.h3`
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.secondary};
    line-height: 1.7;
    padding: 5px 0;
`;

export const Title = styled.h3`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.7;
    padding: 5px 0;
`;

export const Description = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50%;
`;

export const StatusWrapper = styled.div`
    position: absolute;
    bottom: 10px;
    right: 10px;
`;
